import React, { Fragment } from "react";
import Button from "./Button";
import { iconDeleteDropdown, iconEdit, iconFileDropdown, iconDownload } from "./icons";

const Card = ({ title, id, accion, handler, body}) => {
  //let filename = data && data.url ? data.url.split('/') : ""
  return (
    <Fragment key={id}>
      <div
        className={`rd--file-card`}
      >
        <div className="rd--file-card__content"> 
          <div className="rd--file-card__info">
            <div className="rd--file-card__info-name file">
              {iconFileDropdown}
              <span><b>{title}</b></span>
            </div>
          </div>
            {body}
          <br/>
          <div className="d-flex-center w100">
            {accion && <Button
              primary
              size="small"
              onClick={()=> handler()}
            >
              {accion}
            </Button>
            }
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Card;
